import styled from 'styled-components';
import IcoW01 from 'dc/IcoW01';
import { Ico24 } from 'dc/Ico';

type WrapperProps = {
  color: string;
};

export const Wrapper = styled.div<WrapperProps>`
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 46px 16px 20px;
  border-radius: 16px;
  width: 100%;
  max-width: 288px;
  text-align: left;
  background: ${props => props.color};
`;

export const Title = styled.span`
  position: relative;
  font-size: 20px;
  line-height: 120%;
  font-weight: bold;
  margin-bottom: 16px;
  color: #fff;
  width: 100%;
`;

export const Text = styled.span`
  position: relative;
  font-size: 16px;
  line-height: 120%;
  font-weight: normal;
  color: #fff;
  width: 100%;
  padding-bottom: 2px;
`;

type KnowledgeWrapperProps = {
  color: string;
};

export const KnowledgeWrapper = styled.div<KnowledgeWrapperProps>`
  width: 50px;
  height: 50px;
  border-radius: 0px 16px 0px 40px;
  background: ${props => props.color};
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

export const KnowledgeIcon = styled(IcoW01)`
  padding: 10px 10px 16px 16px;
  cursor: pointer;
`;

export const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

type QuestionWrapperProps = {
  borderColor: string;
};

export const QuestionWrapper = styled.div<QuestionWrapperProps>`
  height: 24px;
  width: 24px;
  border: 3px solid ${props => props.borderColor};
  border-radius: 50%;
  margin-right: 8px;
`;

export const QuestionIcon = styled(Ico24)`
  position: relative;
  top: -3px;
  left: -3px;
`;

export const SmallText = styled.span`
  position: relative;
  font-family: Hind;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  color: #fff;
`;

export const Icon = styled(IcoW01)`
  position: absolute;
  bottom: 8px;
  right: 0;
  cursor: pointer;
`;
